import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './LandingPage.css';

const LandingPage = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Store email in localStorage for persistence
    localStorage.setItem('userEmail', email);
    
    try {
      // Subscribe to mailing list
      const response = await fetch('/.netlify/functions/sender-subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          firstName: '',
          lastName: ''
        })
      });

      const result = await response.json();
      console.log('Landing page subscription result:', {
        email: email,
        status: response.ok ? 'success' : 'error',
        response: result
      });

      if (!response.ok) {
        console.error('Subscription error:', result.error);
      }
    } catch (error) {
      console.error('Subscription error:', error);
    }

    // Redirect to quiz page
    navigate('/quiz/2');
  };

  return (
    <div className="landing-page-container">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-main">
            <h1>Your Perfect Ring Awaits</h1>
            <p>Experience the joy of finding your dream diamond ring, guided by experts who understand that this moment deserves to be as beautiful as your love story. No pressure, no overwhelm—just a seamless journey to your perfect match.</p>
          </div>
          <div className="hero-form">
            <h2>Start Your Journey</h2>
            <p>Join thousands of couples who found their perfect ring with us. Get personalized recommendations and exclusive offers.</p>
            <form onSubmit={handleSubmit} className="email-form">
              <input
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="cta-button">Get Your Free Consultation</button>
            </form>
          </div>
        </div>
      </section>

      {/* Value Proposition Section */}
      <section className="value-prop">
        <div className="value-prop-grid">
          <div className="value-card celebrate">
            <div className="value-content">
              <h3>A Joyful Start to Forever</h3>
              <p>Finding the perfect ring should feel exciting, not exhausting. Our 2-minute Style Quiz is just the beginning—your personal concierge will hand-select conflict-free diamond options tailored to your love story, budget, and unique taste. No algorithms, no overwhelm—just expert-curated choices, so you can focus on the magic ahead.</p>
            </div>
          </div>
          <div className="value-card precision">
            <div className="value-content">
              <h3>Your Vision, Perfected by Experts</h3>
              <p>Forget scrolling endlessly. After your quiz, a specialist reviews your preferences and handpicks your top ring designs. Want to adjust the setting, stone size, or metal? Your dedicated diamond concierge will refine every detail until it's uniquely yours.</p>
            </div>
          </div>
          <div className="value-card sustainable">
            <div className="value-content">
              <h3>Ethical Beauty, No Compromises</h3>
              <p>Lab-grown diamonds offer identical brilliance, clarity, and durability as mined diamonds—but with a clear conscience. Sustainably created, budget-friendly, and certified conflict-free, they let you celebrate love without sacrifice.</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <h2>How It Works</h2>
        <div className="steps-container">
          <div className="step">
            <div className="step-number">1</div>
            <h3>Tell Us Your Preferences</h3>
            <p>Share your style, budget, and requirements</p>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <h3>Get Matched</h3>
            <p>We'll find diamonds that match your criteria</p>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <h3>Choose Your Diamond</h3>
            <p>Select from our curated selection</p>
          </div>
          <div className="step">
            <div className="step-number">4</div>
            <h3>Easy Purchase</h3>
            <p>Complete your purchase with confidence</p>
          </div>
        </div>
        <a href="mailto:contact@elysianstonedesign.com" className="cta-button">Contact Us</a>
      </section>

      {/* Footer Section */}
      <footer className="footer" style={{marginTop: '0px'}}>
        <div className="footer-content">
          <div className="footer-section about">
            <h4>About Us</h4>
            <p>
              <strong>Make buying a ring feel as good as the moment it represents.</strong>
            </p>
            <p style={{textAlign: 'center'}}>
              No pressure. No guesswork. Just clarity, joy, and beautiful rings.<br/>
            </p>
            <p style={{marginBottom:'10px', textAlign: 'center'}}>
              <span style={{ display: 'block', marginTop: '1em' }}>
                <Link to="/our-story" style={{ color: '#f2e9e4', textDecoration: 'underline' }}>Read our full story</Link>
              </span>
            </p>
          </div>
          <div className="footer-section contact">
            <h4>Contact Us</h4>
            <p>Email: contact@elysianstonedesign.com</p>
          </div>
          <div className="footer-section others">
            <h4>Others</h4>
            <ul>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-copyright">
          &copy; {new Date().getFullYear()} Elysian Stone Design. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default LandingPage; 